import { useTranslation } from 'react-i18next';
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  InboxOutlined,
  KeyOutlined,
  MoreOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Dropdown,
  Form,
  Layout,
  message,
  Modal,
  Popconfirm,
  Progress,
  Row,
  Space,
  Spin,
  Switch,
  TableColumnsType,
  TableProps,
  Tooltip,
} from "antd";
import Dragger from "antd/es/upload/Dragger";
import { UploadProps } from "antd/lib";
import { get, isEmpty } from "lodash";
import React, {
  ChangeEvent,
  KeyboardEvent,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import DetailLecturerAccountAdminDrawer from "../../components/drawer/lecturer-account";
import ChangePassLecturerDrawer from "../../components/drawer/lecturer-account/change-password";
import CommonModal from "../../components/modal/common";
import ListTeacherAccountImportModal from "../../components/modal/list-teacher-account-import";
import PageHeader from "../../components/page-header/PageHeader";
import TableData from "../../components/table-data/TableData";
import { Permission } from "../../layout/sidebar/permission.enum";
import { HelpService } from "../../service/helper.service";
import {
  changeStatusAccountTeacher,
  createAccountTeacher,
  deleteAccountTeacher,
  downloadExcelLecturerTemplate,
  getAllAccountTeacher,
  getDataTeachers,
  importExcelFileLecturer,
  saveApprovedLecturerAccount,
} from "../../service/list-account-teachers/listAccountTeachersApi";
import {
  changePermissionAccount,
  getOffices,
  getRoles,
  getUnits,
} from "../../service/list-account-users/listAccountUsersApi";
import { globalStore } from "../../stores/stores";
import { DataType } from "../../types/listUsers";
import { combineArray } from "../../utils/arrays";
import { formatOriginTime } from "../../utils/converDate";
import { getCurrentPageFromLink } from "../../utils/getPageFromLink";
import FormFilter from "./components/filter-group/FormFilter";
import FilterTable from "./components/filter-table/FilterTable";
import FormCreateTeacher from "./components/form-create-teacher/FormCreateTeacher";
import { validateFormCreate } from "./constants/data";
import FormItemDropdown from "../../components/form-dropdown/FormItemDropdown";
import "./list-teacher.scss";
import { getRoleDefaultAccount } from "../../service/management-participate-platform";

type ListTeachersProps = {
  title?: string;
};

const ListTeacher = ({ title }: ListTeachersProps) => {
  const { t } = useTranslation();
  const helpService = new HelpService();
  const validations = {
    type: {
      required: true,
      message: t("Vui lòng chọn loại tài khoản", "Vui lòng chọn loại tài khoản"),
    },
    role: {
      required: true,
      message: t("Vui lòng chọn vai trò", "Vui lòng chọn vai trò"),
    },
  };
  const [loading, setLoading] = useState<boolean>(true);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchValue, setSearchValue] = useState<string>("");
  const [form] = Form.useForm();
  const [accountUsers, setAccountUsers] = useState<DataType[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [isOpenImportLecture, setIsOpenImportLecture] =
    useState<boolean>(false);
  const [statusOrder, setStatusOrder] = useState<string>("desc");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("dateJoined");
  const [isOpenLecturerAccountAdmin, setIsOpenLecturerAccountAdmin] =
    useState<boolean>(false);
  const [isOpenChangePass, setIsOpenChangePass] = useState<boolean>(false);
  const [detailData, setDetailData] = useState<any>();
  const [mode, setMode] = useState<string>("");
  const [countItem, setCountItem] = useState<number>(0);
  const [fileList, setFileList] = useState<any>([]);
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [uploadComplete, setUploadComplete] = useState<boolean>(false);
  const [importMode, setImportMode] = useState<boolean>(false);
  const [isDisableSaveButton, setIsDisableSaveButton] = useState<boolean>(true);
  const [isOpenListTeacherImport, setIsOpenListTeacherImport] =
    useState<boolean>(false);

  const navigate = useNavigate();
  const { personalInfo, reload } = globalStore();
  const permissions = personalInfo?.permissions;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userDetail, setUserDetail] = useState<any>({});
  const [selectedPermission, setSelectedPermission] = useState<string>("");
  const [selectedRoles, setSelectedRoles] = useState<number[]>([]);
  const [listRole, setListRole] = useState<any>([]);
  const [isDaiHoc, setIsDaiHoc] = useState<boolean>(false);
  const [loadingSave, setLoadingSave] = useState<boolean>(false);
  const [loadingRole, setLoadingRole] = useState<boolean>(false);
  const [isUserTypeAccount, setIsUserTypeAccount] = useState<boolean>(false);

  const [dataOptions, setDataOptions] = useState({
    dataUnits: [],
    dataRoles: [],
    dataOffices: [],
  });
  const [filterData, setFilterData] = useState<any>({
    universityId: null,
    status: null,
    approvedDate: null,
  });

  const options = [
    {
      key: "3",
      label: t("Thay đổi tài khoản", "Thay đổi tài khoản"),
      icon: <UserSwitchOutlined />,
    },
    ...(permissions?.includes(Permission.ChangeLecturerAccountUpdate)
      ? [
          {
            key: "0",
            label: t("Sửa tài khoản", "Sửa tài khoản"),
            icon: <EditOutlined />,
          },
          {
            key: "1",
            label: t("Đổi mật khẩu", "Đổi mật khẩu"),
            icon: <KeyOutlined />,
          },
        ]
      : []),
    ...(permissions?.includes(Permission.DeleteLecturerAccountUpdate)
      ? [
          {
            key: "2",
            label: t("Xóa tài khoản", "Xóa tài khoản"),
            icon: <DeleteOutlined />,
            className: "dropdown-delete",
            danger: true,
          },
        ]
      : []),
  ];

  const exportExcel = (fileData: any, msg: string) => {
    const blob = new Blob([fileData], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);

    downloadLink.download = msg;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    message.success(t("Tải xuống thành công!", "Tải xuống thành công!"));
  };

  const getListData = async () => {
    setLoading(true);

    const data = {
      page: pageNumber,
      size: pageSize,
      sort: statusOrder ? [`${fieldSortOrder},${statusOrder}`] : [],
      keyword: searchValue.trim() || undefined,
      enterpriseId: check ? null : filterData.universityId,
      isDaiHoc: filterData.universityId ? isDaiHoc : false,
      organizationId: undefined,
      createdFromDate:
        !isEmpty(filterData.approvedDate) &&
        !isEmpty(filterData.approvedDate?.[0])
          ? `${filterData.approvedDate?.[0]}T00:00:00.000Z`
          : null,
      createdToDate:
        !isEmpty(filterData.approvedDate) &&
        !isEmpty(filterData.approvedDate?.[1])
          ? `${filterData.approvedDate?.[1]}T00:00:00.000Z`
          : null,
      status: !filterData.status
        ? null
        : filterData.status === 1
        ? false
        : true,
    };

    await getAllAccountTeacher(data)
      .then((res) => {
        const { data } = res.data;
        setAccountUsers(data.data);
        setTotalRecords(data.total);
        setCountItem(data?.count);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch((err) => {
        if (err.response?.status === 403) {
          navigate("/error/403");
        } else {
          console.error(err);
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    getListData();
  }, [pageSize, pageNumber, statusOrder, reload]);

  const dataColumnsTeachers: TableColumnsType<DataType> = [
    {
      title: t("STT", "STT"),
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 10,
      render: (_: any, record: any, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Tên đăng nhập", "Tên đăng nhập"),
      dataIndex: "username",
      key: "username",
      sorter: true,
      width: 30,
    },
    {
      title: t("Họ và tên người dùng", "Họ và tên người dùng"),
      dataIndex: "name",
      key: "name",
      width: 30,
    },
    {
      title: t("Trường đại học", "Trường đại học"),
      dataIndex: "unitName",
      key: "unitName",
      width: 20,
    },
    {
      title: t("Vai trò", "Vai trò"),
      dataIndex: "vaiTros",
      key: "vaiTros",
      width: 30,
      render: (_: any, record: any) => {
        const roles = record?.roles || [];

        const content = roles?.map((item: any, index: number) => (
          <p
            key={index}
            className="border rounded-md w-fit p-1 mt-1 bg-gray-100 break-all"
          >
            {item?.name}
          </p>
        ));

        return (
          <Tooltip
            title={
              <div style={{ maxHeight: "30vh", overflow: "auto" }}>
                {roles.map((item: any, idx: number) => (
                  <div key={idx}>{item?.name}</div>
                ))}
              </div>
            }
            mouseEnterDelay={0.5}
            placement="topLeft"
          >
            <div
              style={{
                maxHeight: "10vh",
                overflow: "hidden",
              }}
            >
              {content}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: t("Ngày tạo", "Ngày tạo"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: 20,
      render: (_: any, record: any) => {
        return (
          <>
            {record?.dateJoined ? formatOriginTime(record?.dateJoined) : null}
          </>
        );
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      dataIndex: "status",
      key: "status",
      // shouldCellUpdate(record, prevRecord) {
      //   return true
      // },
      render: (_: any, record: any) => {
        const handleChange = (
          checked: boolean,
          event: React.MouseEvent<HTMLButtonElement>
        ) => {
          record.isActive = checked;
        };

        const confirm = (id: number) => {
          const data = {
            usedId: record?.id,
            isActive: record?.isActive,
          };
          changeStatusAccountTeacher(data).then((res) => {
            if (res.status === 200) {
              // record.isActive = !record?.isActive;
              helpService.successMessage(
                record?.isActive ? t("Mở khóa tài khoản thành công", "Mở khóa tài khoản thành công") : t("Khóa tài khoản thành công", "Khóa tài khoản thành công")
              );
              getListData();
            }
          });
        };

        const cancel = () => {};

        if (permissions?.includes(Permission.LockUnlockFAAccountUpdate)) {
          return (
            <Popconfirm
              description={record.isActive ? t("Bạn có chắc chắn muốn khóa tài khoản?", "Bạn có chắc chắn muốn khóa tài khoản?") : t("Bạn có chắc chắn muốn mở khóa tài khoản?", "Bạn có chắc chắn muốn mở khóa tài khoản?")}
              overlayClassName="change-status-popconfirm"
              onConfirm={() => confirm(get(record, "id"))}
              onCancel={cancel}
              okText={record.isActive ? t("Khóa", "Khóa") : t("Mở", "Mở")}
              cancelText={t("Huỷ", "Huỷ")}
              title=""
            >
              <Switch
                defaultChecked={record.isActive}
                checked={record.isActive}
                onChange={handleChange}
              />
            </Popconfirm>
          );
        } else {
          return (
            <Switch
              defaultChecked={record.isActive}
              checked={record.isActive}
              onChange={() => message.error(t("Không có quyền chỉnh sửa!", "Không có quyền chỉnh sửa!"))}
            />
          );
        }
      },
      width: 20,
    },
    {
      title: "",
      dataIndex: "action",
      key: "operation",
      render: (_, record) => {
        return (
          <Space className="flex justify-center">
            <a
              className="action-table"
              onClick={() => {
                setIsOpenLecturerAccountAdmin(true);
                setDetailData(record);
              }}
            >
              <EyeOutlined />
            </a>
            <Dropdown
              menu={{
                items: options,
                onClick: ({ key }) => {
                  if (key === "0") {
                    setIsOpened(true);
                    setMode("edit");
                    setDetailData(record);
                  }
                  if (key === "1") {
                    setIsOpenChangePass(true);
                    setDetailData(record);
                  }
                  if (key === "2") {
                    Modal.confirm({
                      title: t("Xoá tài khoản", "Xoá tài khoản"),
                      content: t("Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?", "Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?"),
                      onOk: () => deleteAccount(record.id),
                      centered: true,
                      okText: t("Xác nhận", "Xác nhận"),
                      cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
                      footer: (_, { OkBtn, CancelBtn }) => (
                        <>
                          <CancelBtn />
                          <OkBtn />
                        </>
                      ),
                    });
                  }
                  if (key === "3") {
                    if (record.username === personalInfo.email) {
                      message.error(t("Bạn không thể tự thay đổi tài khoản của mình!", "Bạn không thể tự thay đổi tài khoản của mình!"));
                      return;
                    }

                    setIsModalOpen(true);
                    setUserDetail(record);

                    let permission = "";
                    switch (record.role) {
                      case "is_qtdh":
                        permission = "1";
                        break;
                      case "is_qtcs":
                        permission = "2";
                        break;
                      case "is_giang_vien":
                        permission = "3";
                        break;
                      default:
                        break;
                    }

                    form.setFieldValue(
                      "roleAccount",
                      record.roles?.map((item: any) => {
                        return String(item.id);
                      })
                    );
                    setIsUserTypeAccount(true);
                    setSelectedPermission(permission);
                  }
                },
              }}
              placement="bottomRight"
            >
              <Button>
                <MoreOutlined />
              </Button>
            </Dropdown>
          </Space>
        );
      },
      fixed: "right",
      width: 15,
    },
  ];

  const defaultCheckedList = dataColumnsTeachers.map(
    (item) => item.key as string
  );

  const [checkedList, setCheckedList] = useState(defaultCheckedList);

  const columnsChecked = useMemo(() => {
    return dataColumnsTeachers.map((item) => ({
      ...item,
      hidden: !checkedList.includes(item.key as string),
    }));
  }, [checkedList, permissions]);

  const handleOpenCreate = () => {
    setIsOpened(true);
    setMode("add");
  };
  const handleOpenImport = () => {
    setIsOpenImportLecture(true);
  };

  const openFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const handleClose = () => {
    setIsOpened(false);
    form.resetFields();
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setSearchValue(value);
    setPageNumber(1);
    if (value.length === 0) {
      setSearchValue("");
    }
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      getListData();
    }
  };

  const handleSubmitSearch = () => {
    getListData();
  };

  const check = !permissions?.includes(Permission.isQTHT);

  const clearFilter = () => {
    const allFields = form.getFieldsValue();
    const fieldsToReset = Object.keys(allFields).filter(
      (key) => key !== "universityId"
    );
    check ? form.resetFields(fieldsToReset) : form.resetFields();

    setFilterData({
      universityId: check ? filterData.universityId : null,
      status: null,
      approvedDate: null,
    });
  };

  const onFinishCreate = (values: any) => {
    createAccountTeacher(values)
      .then((res) => {
        const { data, statusCode } = res.data;
        if (statusCode === 200) {
          helpService.successMessage(
            get(data, "message", t("Tạo tài khoản thành công", "Tạo tài khoản thành công"))
          );
          form.resetFields();
          setPageNumber(1);
          handleClose();
        }
      })
      .catch((err) => {});
  };

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
        ? "desc"
        : "";
    setStatusOrder(data);
    setFieldSortOrder(sorter.field);
  };

  const handleChangeFilter = (value: any, name: string) => {
    setFilterData({ ...filterData, [name]: value });
  };

  const handleCloseFilter = () => {
    setShowFilter(false);
  };

  const handleFinish = (values: any) => {
    setLoading(true);
    getDataTeachers({
      vaiTros: get(values, "vaiTros", []),
      donVis: combineArray(dataOptions.dataUnits, get(values, "donVis", [])),
      trangThai: get(values, "trangThai", []),
    }).then((res) => {
      const { data, totalRecords } = res.data.data;
      setLoading(false);
    });
  };

  const deleteAccount = async (id: number) => {
    try {
      const res = await deleteAccountTeacher(id);
      if (res.status === 200) {
        message.success(t("Xóa tài khoản thành công", "Xóa tài khoản thành công"));
        if (countItem === 1 && pageNumber > 1) {
          setPageNumber(pageNumber - 1);
        } else {
          getListData();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const changeHandler = async (event: any) => {
    if (isEmpty(event.fileList)) {
      setFileList([]);
      return;
    }

    setFileList(event.fileList);
    const file = event.fileList[0]?.originFileObj;
    if (!file) return;

    message.warning(t("Đang import File, vui lòng đợi...", "Đang import File, vui lòng đợi..."));
    const formData = new FormData();
    formData.append("file", file);
    setImportMode(true);
    setUploadProgress(0);
    setUploadComplete(false);
    try {
      const res = await importExcelFileLecturer(formData, {
        onUploadProgress: (progressEvent: ProgressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percent - 30);
            if (percent >= 100) {
              setUploadComplete(true);
            }
          }
        },
      });

      if (res.status === 200) {
        setUploadProgress(100);
        message.success(t("Import File thành công!", "Import File thành công!"));
        setImportMode(false);
        setIsDisableSaveButton(false);
      }
    } catch (err) {
      console.error(err);
      setIsDisableSaveButton(true);
    } finally {
      setImportMode(false);
    }
  };
  const propsFile: UploadProps = {
    name: "file",
    // multiple: true,
    maxCount: 1,
    beforeUpload: (file) => {
      const isExcel =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isExcel) {
        message.error(`${file.name} ${t("không phải file Excel", "không phải file Excel")}`);
      }
      return false;
    },
    onChange: changeHandler as any,
    fileList: fileList,
  };

  const downloadTemplate = async () => {
    await downloadExcelLecturerTemplate().then((res) => {
      if (res.status === 200) {
        exportExcel(res.data, `${t("File mẫu", "File mẫu")}.xlsx`);
      }
    });
  };

  const saveAccount = async () => {
    const data = {
      isApproved: true,
    };
    await saveApprovedLecturerAccount(data).then((res) => {
      if (res.status === 200) {
        message.success(t("Thêm giảng viên từ File thành công", "Thêm giảng viên từ File thành công"));
        setIsOpened(false);
        setIsOpenListTeacherImport(false);
        setTimeout(() => {
          setIsOpenImportLecture(false);
        }, 0);
        getListData();
      }
    });
  };

  const handleConfirmFile = async () => {
    setIsOpenListTeacherImport(true);
  };

  // get role
  const getRoleByPermission = async () => {
    setLoadingRole(true);
    const data = {
      keyword: "",
      pageNumber: 1,
      pageSize: 999999,
      checkRole: selectedPermission === "3" ? "2" : "1",
    };

    try {
      const res = await getRoleDefaultAccount(data);
      if (res.data.statusCode === 200) {
        const listData = res.data?.data?.map((role: any) => ({
          value: role.id,
          label: role.name,
        }));
        setListRole(listData);
        setLoadingRole(false);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingRole(false);
    }
  };

  // Change permission
  const changePermission = async () => {
    setLoadingSave(true);
    const dataReq = {
      userIds: [userDetail.id],
      typeAccount: Number(selectedPermission),
      universityUUID: userDetail.uuid,
      groupIds: selectedRoles,
    };
    try {
      const res = await changePermissionAccount(dataReq);
      if (res.status === 200) {
        setLoadingSave(false);
        message.success(t("Thay đổi vai trò thành công", "Thay đổi vai trò thành công"));
        handleCancel();
        getListData();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingSave(false);
      handleCancel();
    }
  };

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedRoles([]);
    setSelectedPermission("");
    form.resetFields();
  };

  const permissionOptions = [
    ...((permissions?.includes(Permission.isQTDH) ||
      permissions?.includes(Permission.isMinistry) ||
      permissions?.includes(Permission.isQTHT)) &&
    (userDetail.role === "is_qtdh" || userDetail.unitParentUuid)
      ? [
          {
            value: "1",
            label: t("Quản trị đại học", "Quản trị đại học"),
          },
        ]
      : []),
    {
      value: "2",
      label: t("Quản trị cơ sở", "Quản trị cơ sở"),
    },
    {
      value: "3",
      label: t("Giảng viên", "Giảng viên"),
    },
  ];

  useEffect(() => {
    if (selectedPermission) {
      form.setFieldValue("typeAccount", selectedPermission);
      getRoleByPermission();
    }
  }, [selectedPermission]);

  useEffect(() => {
    const pageLink = getCurrentPageFromLink(location.search);
    if (!isEmpty(pageLink)) {
      setPageNumber(Number(pageLink));
    } else {
      const fetchDataOptions = async () => {
        const response = await Promise.all([
          getRoles(),
          getUnits(),
          getOffices(),
        ]);
        const dataRoles = response[0].data.data;
        const dataUnits = response[1].data.data;
        const dataOffices = response[2].data.data;
        setDataOptions({
          ...dataOptions,
          dataOffices: dataOffices,
          dataUnits: dataUnits,
          dataRoles: dataRoles,
        });
      };
      fetchDataOptions();
    }
  }, []);

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;
    if (uploadComplete && importMode) {
      setUploadProgress(70);
      timer = setInterval(() => {
        setUploadProgress((prev) => (prev < 99 ? prev + 1 : prev));
      }, 500);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [uploadComplete, importMode]);

  useEffect(() => {
    setFileList([]);
    setUploadProgress(0);
    setUploadComplete(false);
  }, [isOpenImportLecture]);

  return (
    <Layout className="page-header-group">
      <Form.Provider
        onFormFinish={(name, { values, forms }) => {
          if (name === "createTeacher") {
            const { createTeacher } = forms;
            const data = createTeacher.getFieldsValue(validateFormCreate);
            onFinishCreate(data);
          }
          if (name === "filterForm") {
            getListData();
          }
        }}
      >
        <div
          className={`page-header-group--layout ${
            showFilter ? "open-filter" : ""
          }`}
        >
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader title={title} />
            </div>
            <FilterTable
              handleOpen={handleOpenCreate}
              searchValue={searchValue}
              dataColumns={dataColumnsTeachers}
              handleOpenFilter={openFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
              handleChangeInput={handleChangeInput}
              handleOpenImport={handleOpenImport}
            />
          </div>
          <FormFilter
            form={form}
            check={check}
            showFilter={showFilter}
            filterData={filterData}
            clearFilter={clearFilter}
            setIsDaiHoc={setIsDaiHoc}
            setFilterData={handleChangeFilter}
            handleCloseFilter={handleCloseFilter}
          />
        </div>
        <TableData
          dataTable={accountUsers}
          dataColumns={columnsChecked}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          pageSize={pageSize}
          pagination={true}
          loadingTable={loading}
          scroll={{ x: 1500, y: 600 }}
          totalRecords={totalRecords}
          handleTableChangeProps={handleTableChange}
        />

        <FormCreateTeacher
          mode={mode}
          open={isOpened}
          handleClose={handleClose}
          fetchData={getListData}
          detailData={detailData}
        />
        <DetailLecturerAccountAdminDrawer
          open={isOpenLecturerAccountAdmin}
          onClose={() => setIsOpenLecturerAccountAdmin(false)}
          detailData={detailData}
        />

        <ChangePassLecturerDrawer
          open={isOpenChangePass}
          onClose={() => setIsOpenChangePass(false)}
          detailData={detailData}
          fetchData={getListData}
        />

        <CommonModal
          open={isOpenImportLecture}
          title={t("Thêm tài khoản giảng viên từ file Excel", "Thêm tài khoản giảng viên từ file Excel")}
          maskClosable={false}
          desc={
            <div className="border-b pb-3">
              <Dragger {...propsFile} showUploadList={false}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  {t("Nhấn hoặc thả tệp lên từ máy tính của bạn", "Nhấn hoặc thả tệp lên từ máy tính của bạn")}{" "}
                  <span className="text-[#1677FF]">{t("vào đây", "vào đây")}</span>
                </p>
                <p className="ant-upload-hint">
                  {t("Định dạng tệp khả dụng: CSV (Tối đa 01 tệp - 10 MB)", "Định dạng tệp khả dụng: CSV (Tối đa 01 tệp - 10 MB)")}
                </p>
              </Dragger>
              {uploadProgress > 0 && <Progress percent={uploadProgress} />}
              {uploadProgress < 100 && uploadProgress > 0 && (
                <div className="loader-upload-file" data-text={t("Hệ thống đang xử lý, xin vui lòng chờ.....", "Hệ thống đang xử lý, xin vui lòng chờ.....")}></div>
              )}
              {uploadProgress === 100 && <div>{fileList[0]?.name}</div>}
              <div className="pt-3">
                <span className="font-bold">
                  {t("Hướng dẫn các bước thêm giảng viên từ file Excel:", "Hướng dẫn các bước thêm giảng viên từ file Excel:")}
                </span>
                <ol className="list-decimal px-4">
                  <li className="list-decimal">
                    {t("Tải mẫu file Excel chuẩn mà bạn cần sử dụng", "Tải mẫu file Excel chuẩn mà bạn cần sử dụng")}{" "}
                    <span
                      className="text-[#1677FF] cursor-pointer"
                      onClick={downloadTemplate}
                    >
                      {t("tại đây", "tại đây")}
                    </span>
                  </li>
                  <li className="list-decimal">
                    {t("Nhấn hoặc thả tệp cần tải lên vào khu vực tải tệp", "Nhấn hoặc thả tệp cần tải lên vào khu vực tải tệp")}
                  </li>
                  <li className="list-decimal">
                    {t("Chọn nút “Lưu“ để tải file lên hệ thống", "Chọn nút “Lưu“ để tải file lên hệ thống")}
                  </li>
                </ol>
              </div>
            </div>
          }
          closeIcon={true}
          okText={t("Lưu", "Lưu")}
          cancelText={t("Huỷ", "Huỷ")}
          icon=""
          loading={importMode}
          disableButton={isDisableSaveButton}
          confirm={handleConfirmFile}
          closeModal={() => setIsOpenImportLecture(false)}
          className={"!w-full md:!w-[520px]"}
        />

        <ListTeacherAccountImportModal
          open={isOpenListTeacherImport}
          handleClose={() => setIsOpenListTeacherImport(false)}
          importMode={importMode}
          saveAccount={saveAccount}
        />

        <Modal
          title={t("Thay đổi tài khoản", "Thay đổi tài khoản")}
          maskClosable={false}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          okText={t("Lưu", "Lưu")}
          cancelText={t("Hủy", "Hủy")}
          okButtonProps={{ disabled: loadingSave || isUserTypeAccount }}
          cancelButtonProps={{ disabled: loadingSave }}
          className="change-permission-modal"
        >
          <Form form={form} onFinish={() => changePermission()}>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="typeAccount"
                  label={t("Loại tài khoản", "Loại tài khoản")}
                  rules={[validations.type]}
                >
                  <FormItemDropdown
                    options={permissionOptions}
                    placeholder={t("Chọn loại tài khoản", "Chọn loại tài khoản")}
                    onChange={(value) => {
                      setSelectedPermission(value);
                      setSelectedRoles([]);

                      let permission = "";
                      switch (userDetail.role) {
                        case "is_qtdh":
                          permission = "1";
                          break;
                        case "is_qtcs":
                          permission = "2";
                          break;
                        case "is_giang_vien":
                          permission = "3";
                          break;
                        default:
                          break;
                      }

                      if (value === permission) {
                        setIsUserTypeAccount(true);
                        form.setFieldValue(
                          "roleAccount",
                          userDetail.roles?.map((item: any) => {
                            return String(item.id);
                          })
                        );
                      } else {
                        setIsUserTypeAccount(false);
                        form.setFieldValue("roleAccount", []);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col className="flex roles-col" span={24}>
                <div
                  style={{
                    minHeight: 32,
                    width: "100%",
                    alignContent: "center",
                  }}
                >
                  <Form.Item
                    name="roleAccount"
                    label={t("Vai trò", "Vai trò")}
                    rules={[validations.role]}
                  >
                    {loadingRole ? (
                      <Spin size="small" />
                    ) : (
                      <FormItemDropdown
                        allowClear
                        options={listRole}
                        modeDropdown="multiple"
                        placeholder={t("Chọn vai trò", "Chọn vai trò")}
                        disabled={isUserTypeAccount}
                        onChange={(value) =>
                          setSelectedRoles(value?.map(Number))
                        }
                      />
                    )}
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Form.Provider>
    </Layout>
  );
};

export default ListTeacher;
